<style scoped>
.style-toggle {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 1;
	width: 32px;
	height: 32px;
	border: none;
	border-radius: 4px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	cursor: pointer;
	background-color: #fff;
	color: #333;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.style-toggle:hover {
	background-color: #e9ecef;
}

.style-toggle.active {
	background-color: #0d6efd;
	color: #fff;
}
</style>

<template>
	<button
		class="style-toggle"
		:class="{ active: modelValue === ALIDADE_SATELLITE }"
		:title="modelValue === ALIDADE_SATELLITE ? 'Switch to map' : 'Switch to satellite'"
		@click="toggle"
	>
		<i v-if="modelValue === ALIDADE_SATELLITE" class="bi bi-map"></i>
		<i v-else class="bi bi-globe2"></i>
	</button>
</template>

<script setup lang="ts">
import { ALIDADE_SMOOTH, ALIDADE_SATELLITE } from "@/map/constants";

const props = defineProps<{
	modelValue: string;
}>();

const emit = defineEmits<{
	"update:modelValue": [style: string];
}>();

function toggle() {
	emit(
		"update:modelValue",
		props.modelValue === ALIDADE_SMOOTH ? ALIDADE_SATELLITE : ALIDADE_SMOOTH,
	);
}
</script>
